import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import "../libs/css/custom-bootstrap-margin-padding.css";
import { useNavigate } from "react-router-dom";
import { API_ROUTES } from "../utils/constants";

export default function Login({ objectToFormData }) {
  const [showPassword, setShowPassword] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();

  // Load remember me and input data from localStorage
  const rememberLogin = localStorage.getItem("rememberLoginFs");
  const rememberMe = rememberLogin ? true : false;
  const userInput = JSON.parse(localStorage.getItem("userVASInputs")) || {};
  const isEmail = userInput ? atob(userInput.email || "") : "";
  const isPassword = userInput ? atob(userInput.password || "") : "";

  // Setup form and validation
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      email: rememberMe ? isEmail : "",
      password: rememberMe ? isPassword : "",
      remember: rememberMe,
    },
  });

  // Check if user is authenticated
  const userData = JSON.parse(localStorage.getItem("userVASData"));
  const isAuthenticated = userData?.isLoggedIn;

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
    document.title = "Admin Login | Oatek VAS";
  }, [isAuthenticated, navigate]);

  // Toggle password visibility
  const togglePassword = () => setShowPassword(!showPassword);

  const loginAuth = async (data) => {
    try {
      const response = await fetch(API_ROUTES.LOG_IN, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      const responseJSON = await response.json();
      // console.log(responseJSON);
      // Check if the response has a token, indicating a successful login
      if (responseJSON.token) {
        // Extract relevant user details
        const userData = {
          isLoggedIn: true,
          responseDetails: {
            userName: responseJSON.userName,
            id: responseJSON.id,
            companyName: responseJSON.companyName,
            email: responseJSON.email,
            token: responseJSON.token, // Store the JWT token in localStorage
            roles: responseJSON.roles,
          },
        };

        // Log the user data for debugging purposes
        // console.log("User Data:", userData);

        // Store user data and token in localStorage
        localStorage.setItem("userVASData", JSON.stringify(userData));

        // Navigate to the correct dashboard based on role
        if (userData.responseDetails.roles.includes("Admin")) {
          navigate("/dashboard");
        } else if (userData.responseDetails.roles.includes("CompanyUser")) {
          // navigate("/dashboard/company");
          setTimeout(() => {
            navigate("/dashboard/company");
          }, 500); // Delay of 500ms (half a second)
        }
      } else {
        // Handle error if no token is received (login failed)
        Swal.fire({
          title: "<font className='error_title'>Error</font>",
          html: responseJSON || "Unknown error",
          icon: "error",
        });
      }
    } catch (error) {
      // Handle unexpected errors (e.g., network issues)
      Swal.fire({
        icon: "error",
        html: error.message,
        title: "Error",
      });
    }
  };

  return (
    <div className="fix-wrapper">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-6">
            <div className="card mb-0 h-auto">
              <div className="card-body">
                <div className="text-center mb-4">
                  <img
                    src="assets/images/oatek_logo.png"
                    style={{ width: "160px" }}
                    alt="Logo"
                  />
                </div>
                <h4 className="text-center mb-4">Sign in your account</h4>
                <form className="theme-form" onSubmit={handleSubmit(loginAuth)}>
                  <div className="form-group">
                    <label htmlFor="username">Email Address</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter email address"
                      {...register("email", { required: "Email is required" })}
                    />
                    {errors.email && (
                      <p className="text-danger">{errors.email.message}</p>
                    )}
                  </div>
                  <div className="form-group position-relative">
                    <label htmlFor="dlabPassword">Password</label>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Enter password"
                      {...register("password", {
                        required: "Password is required",
                      })}
                    />
                    <span
                      className="show-pass eye"
                      onClick={togglePassword}
                      style={{ cursor: "pointer" }}
                      aria-label="Toggle password visibility"
                    >
                      {showPassword ? (
                        <i className="fa fa-eye"></i>
                      ) : (
                        <i className="fa fa-eye-slash"></i>
                      )}
                    </span>
                    {errors.password && (
                      <p className="text-danger">{errors.password.message}</p>
                    )}
                  </div>
                  <div className="form-row d-flex flex-wrap justify-content-between mt--5 mb-5">
                    <div className="form-group"></div>
                    <div className="form-group ms-2">
                      <a className="btn-link" href="forgotpassword">
                        Forgot Password?
                      </a>
                    </div>
                  </div>
                  {/* <div className="text-center">
                    <button
                      type="submit"
                      className="btn btn-primary btn-block"
                      disabled={isSubmitting || !isValid}
                    >
                      Sign Me In
                    </button>
                  </div> */}
                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn btn-primary btn-block"
                      disabled={isSubmitting || !isValid} // Disable button if submitting or form is invalid
                    >
                      {isSubmitting ? (
                        // Show the spinner if the form is submitting
                        <div className="text-center">
                          <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        // Show the button text if not submitting
                        "Sign Me In"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
